/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_EyebrowInputs */

const en_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One Coach. One Method.`)
};

const es_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un entrenador. Un método.`)
};

const de_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Trainer. Eine Methode.`)
};

const zh_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一名教练。一种方法。`)
};

const ar_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدرب واحد. منهج واحد.`)
};

const fr_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un entraîneur. Une méthode.`)
};

const vi_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Một huấn luyện viên. Một phương pháp.`)
};

const sw_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kocha Mmoja. Mbinu Moja.`)
};

const th_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โค้ชหนึ่งคน วิธีหนึ่งเดียว`)
};

const bs_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jedan trener. Jedna metoda.`)
};

const ja_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コーチはひとり。メソッドはひとつ。`)
};

const ko_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`한 명의 코치. 하나의 메서드.`)
};

const pt_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um treinador. Um Método.`)
};

const it_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un coach. Un metodo.`)
};

const sv_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En coach. En metod.`)
};

const nl_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eén Coach. Eén methode.`)
};

const da_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En træner. En metode.`)
};

const nb_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En trener. En metode.`)
};

const fi_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yksi valmentaja. Yksi menetelmä.`)
};

const pl_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeden trener. Jedna metoda.`)
};

const ru_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Один тренер. Один метод.`)
};

const tr_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir Antrenör. Bir Yöntem.`)
};

const hi_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक कोच। एक विधि।`)
};

const id_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu Pelatih. Satu Metode.`)
};

const ms_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seorang Jurulatih. Satu Kaedah.`)
};

const cs_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeden trenér. Jedna metoda.`)
};

const el_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ένας προπονητής. Μία μέθοδος.`)
};

const he_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מאמן אחד שיטה אחת.`)
};

const af_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een afrigter. Een metode.`)
};

const hu_home_eyebrow = /** @type {(inputs: Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egy edző. Egy módszer.`)
};

/**
* | output |
* | --- |
* | "One Coach. One Method." |
*
* @param {Home_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_eyebrow = /** @type {((inputs?: Home_EyebrowInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_EyebrowInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_eyebrow(inputs)
	if (locale === "de") return de_home_eyebrow(inputs)
	if (locale === "zh") return zh_home_eyebrow(inputs)
	if (locale === "ar") return ar_home_eyebrow(inputs)
	if (locale === "fr") return fr_home_eyebrow(inputs)
	if (locale === "vi") return vi_home_eyebrow(inputs)
	if (locale === "sw") return sw_home_eyebrow(inputs)
	if (locale === "th") return th_home_eyebrow(inputs)
	if (locale === "bs") return bs_home_eyebrow(inputs)
	if (locale === "ja") return ja_home_eyebrow(inputs)
	if (locale === "ko") return ko_home_eyebrow(inputs)
	if (locale === "pt") return pt_home_eyebrow(inputs)
	if (locale === "it") return it_home_eyebrow(inputs)
	if (locale === "sv") return sv_home_eyebrow(inputs)
	if (locale === "nl") return nl_home_eyebrow(inputs)
	if (locale === "da") return da_home_eyebrow(inputs)
	if (locale === "nb") return nb_home_eyebrow(inputs)
	if (locale === "fi") return fi_home_eyebrow(inputs)
	if (locale === "pl") return pl_home_eyebrow(inputs)
	if (locale === "ru") return ru_home_eyebrow(inputs)
	if (locale === "tr") return tr_home_eyebrow(inputs)
	if (locale === "hi") return hi_home_eyebrow(inputs)
	if (locale === "id") return id_home_eyebrow(inputs)
	if (locale === "ms") return ms_home_eyebrow(inputs)
	if (locale === "cs") return cs_home_eyebrow(inputs)
	if (locale === "el") return el_home_eyebrow(inputs)
	if (locale === "he") return he_home_eyebrow(inputs)
	if (locale === "af") return af_home_eyebrow(inputs)
	if (locale === "hu") return hu_home_eyebrow(inputs)
	return en_home_eyebrow(inputs)
});